import Immutable from 'seamless-immutable';
import { createReducer } from 'redux-act';

import Actions from '../actions';

const initialState = Immutable({
  byId:                      {},
  removeNotificationMessage: {
    isMessageDisplayed: false,
    emailTemplateId:    null,
  },
});

const reducer = createReducer((on) => {
  on(Actions.fetchNotificationListSuccess, (state, { emailTemplateList }) => {
    const byId = _.reduce(
      emailTemplateList,
      (acc, template) => {
        acc[template.id] = template;
        return acc;
      },
      {}
    );
    return state.set('byId', byId);
  });

  on(Actions.promptRemoveNotification, (state, { emailTemplateId }) => {
    return state.merge(
      {
        removeNotificationMessage: {
          isMessageDisplayed: true,
          emailTemplateId,
        },
      },
      { deep: true }
    );
  });

  //This is called when the user changes his mind and decides not to delete the emailNotification
  on(Actions.cancelRemoveNotification, (state) => {
    return state.setIn(['removeNotificationMessage', 'isMessageDisplayed'], false);
  });

  //This is called when the API returned a success on deleting a notification
  on(Actions.removeNotificationSuccess, (state, { emailTemplateId }) => {
    return state.merge({
      byId:                      state.byId.without(emailTemplateId),
      removeNotificationMessage: { isDisplayed: false, emailTemplateId: null },
    });
  });

  on(Actions.updateNotificationStatusFromList, (state, { emailTemplate }) => {
    return state.setIn(['byId', emailTemplate.id], emailTemplate);
  });

  on(Actions.addNewNotificationToLocalList, (state, { emailTemplate }) => {
    return state.setIn(['byId', emailTemplate.id], emailTemplate);
  });

  on(Actions.updateEmailTemplateSuccess, (state, { emailTemplate }) => {
    return state.setIn(['byId', emailTemplate.id], emailTemplate);
  });
}, initialState);

export default reducer;
